import styled, { css } from "styled-components/macro";


export const FacebookLoginButton =styled.iframe`
    border:none;
    height: clamp(55px, 65px, 200px);
    visibility: ${(props) => props.visible};
`